import React from 'react';
import {
  Controller,
  FieldError,
  RegisterOptions,
  useFormContext,
} from 'react-hook-form';
import { Input } from '@amzn/storm-ui';
import get from 'lodash/get';
import { CustomFormRow } from './style';

interface inputControllerProps {
  label: string;
  id: string;
  controllerName: string;
  labelTopSpacing?: string;
  helpTipText?: string;
  optionalTag?: string;
  registerOptions?: RegisterOptions;
  type?: string;
  disabled?: boolean;
}

const InputController = ({
  label,
  id,
  controllerName,
  labelTopSpacing = '0px',
  helpTipText,
  optionalTag,
  registerOptions,
  type = 'text',
  disabled = false,
}: inputControllerProps) => {
  const {
    control,
    register,
    setValue,
    trigger,
    formState: { errors },
  } = useFormContext();

  return (
    <CustomFormRow
      label={label}
      labelTopSpacing={labelTopSpacing}
      id={id}
      helpTipText={helpTipText}
      optionalTag={optionalTag}
      controlComponents={[
        (componentId: string) => (
          <Controller
            name={controllerName}
            control={control}
            render={({ field }) => (
              <>
                <Input
                  {...register(controllerName, registerOptions)}
                  statusType={
                    (get(errors, controllerName) as FieldError)?.message
                      ? 'error'
                      : undefined
                  }
                  message={(get(errors, controllerName) as FieldError)?.message}
                  id={componentId}
                  fullWidth
                  onChange={(event) => {
                    setValue(controllerName, event.target.value);
                    trigger(controllerName);
                  }}
                  type={type}
                  value={field.value}
                  disabled={disabled}
                />
              </>
            )}
          />
        ),
      ]}
    />
  );
};

export default InputController;
